import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService, IBreadcrumbRoute } from '../../core/breadcrumbs.service';
import { LangService } from '../../core/lang.service';
import { LoginGuardService } from '../../api/login-guard.service';

@Component({
  selector: 'applicant-learnmore',
  templateUrl: './applicant-learnmore.component.html',
  styleUrls: ['./applicant-learnmore.component.scss']
})
export class ApplicantLearnmoreComponent implements OnInit {
  
  breadcrumbPre:IBreadcrumbRoute[];

  constructor(
    private loginGuard: LoginGuardService, // 
    public langService:LangService,
    private breadcrumbsService: BreadcrumbsService
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    this.breadcrumbPre = [
      this.breadcrumbsService.APPLICANT_LANDING(),
      this.breadcrumbsService.APPLICANT_LEARNMORE(),
    ];
  }

  getLearnmoreSection(){
    return this.breadcrumbsService.learnMoreSection.APPLICANT;
  }

}
